import { migrateAssessmentTenantIdStorage, redirectOnStatusCode, setTenantHeaderMiddleware } from "@sg-protect/core";
import config from "@sg-protect/runtime-config";
import createFetchClient from "openapi-fetch";
import { createTenantScopedQueryClient } from "./createTenantScopedQueryClient.ts";
import type { paths } from "./types.ts";

export const client = createFetchClient<paths>({
    baseUrl: config.get().insights.api,
    credentials: "include",
    fetch: (...args) => globalThis.fetch(...args)
});

client.use(setTenantHeaderMiddleware(migrateAssessmentTenantIdStorage.get));

client.use(
    redirectOnStatusCode({
        status: 401,
        to: () => `${config.get().insights.login}?returnUrl=${encodeURIComponent(window.location.href)}`
    })
);

const { useQuery, useSuspenseQuery, useUnscopedQuery, unscopedQueryOptions } = createTenantScopedQueryClient(client);

export { unscopedQueryOptions, useQuery, useSuspenseQuery };

export function scopeQueryKeyToTenant<T extends { queryKey: readonly unknown[] }>(base: T, tenantId: string): T {
    return { ...base, queryKey: [...base.queryKey, tenantId] };
}

/**
 * @knipignore We want to export this even if it's not consumed yet.
 */
export { useUnscopedQuery };
